import { render, staticRenderFns } from "./ActivityVolumeInformation.vue?vue&type=template&id=d6728eca&"
import script from "./ActivityVolumeInformation.vue?vue&type=script&lang=js&"
export * from "./ActivityVolumeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports